// extracted by mini-css-extract-plugin
export default {"events":"EventsList_events__YYO+N","list":"EventsList_list__nlRve","item":"EventsList_item__EtSmr","content":"EventsList_content__fqVtS"};